import React from 'react';
import { HeroSectionWrapper } from './HeroSection.style';
import { ImageCarousel } from '../ImageCarousel/ImageCarousel';
import type { HeroSectionProps } from '../../types/VehicleSectionProps';

export const HeroSection: React.FC<HeroSectionProps> = ({ vehicleData }) => {
    const { year, make, model, vehiclePhotoUrls } = vehicleData;
    const vehicleImageAlt = `${year} ${make} ${model}`.trim();

    return (
        <HeroSectionWrapper data-testid="hero-section">
            <ImageCarousel images={vehiclePhotoUrls} vehicleImageAlt={vehicleImageAlt} />
        </HeroSectionWrapper>
    );
};
